export function QuoteCard() {
  return (
    <div className="bento-no-min row-span-3 flex flex-col h-full">
      <h3 className="font-heading text-md [@media(min-width:414px)]:text-lg text-foreground mb-4">
        Data-Driven Builder
      </h3>
      <p className="font-body text-sm text-muted-foreground font-light leading-relaxed">
        "Whether it’s analyzing complex data, training ML models in Python, or building full-stack applications, my focus stays the same — create solutions that are insightful, reliable, and genuinely drive the project forward. Good tech should uncover value, not just complexity."
      </p>
    </div>
  );
}
